var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"particulars"},[_c('div',{staticClass:"particulars-title"},[_vm._v("-商品详情-")]),_c('div',{staticClass:"detail-img",domProps:{"innerHTML":_vm._s(_vm.info.contents)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }